import React, { FC } from "react";
import { ArtistCaption, Description, HoverImage, ImageContainer, Tile, Title } from "./styles";

interface BaseCollectionTileProps {
  componentId: string;
  description?: string;
  hoverImageUrl?: string;
  href: string;
  imageUrl: string;
  title: string;
  tileType: string;
  brand: string;
}

const BaseCollectionTile: FC<BaseCollectionTileProps> = ({
  componentId,
  description,
  hoverImageUrl,
  href,
  imageUrl,
  title,
  tileType,
  brand,
}) => (
  <Tile
    data-recommendation-clicked
    data-category={title}
    href={href}
    data-component-id={componentId}
    $zoom={!hoverImageUrl}
    brand={brand}
  >
    <ImageContainer tileType={tileType} brand={brand}>
      <img src={imageUrl} alt={title} />
      {hoverImageUrl && <HoverImage src={`https:${hoverImageUrl}`} />}

      {tileType === "Artist" && (
        <ArtistCaption>
          {description && <Description tileType={tileType}>{description}</Description>}
          <Title tileType={tileType}>{title}</Title>
        </ArtistCaption>
      )}
    </ImageContainer>

    {tileType !== "Artist" && (
      <>
        <Title tileType={tileType}>{title}</Title>
        {description && <Description tileType={tileType}>{description}</Description>}
      </>
    )}
  </Tile>
);

export default BaseCollectionTile;
